angular.module('autoremind.templates').controller('autoremind.templates.editDialogController', ['$scope', '$uibModalInstance', '$timeout', 'data', 'messagesService', 'printService',
    function ($scope, $uibModalInstance, $timeout, data, messagesService, printService) {
        $scope.model = [{
                name: 'emailSubject',
                value: 'Hello'
            }, {
                name: 'emailTitle',
                value: 'Greetings'
            }, {
                name: 'emailMessage',
                value: 'This just in...'
            }, {
                name: 'smsMessage',
                value: 'It is about time ...'
            }, {
                name: 'voiceMessage',
                value: 'Hello'
            }];
        $scope.cancel = function () {
            $uibModalInstance.dismiss();
        };
        $scope.save = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
//# sourceMappingURL=admin-templates.change.dialog.controller.js.map